// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"3dfd2dd5","453":"5c16539a","750":"df7b67b4","861":"5e2d90dc","895":"5424f976","945":"965ff04a"}[chunkId] + ".chunk.js";
};